// export const columns = [
//     { field: 'authNo', headerName: 'Auth No', width: 140, headerClassName: 'pink-header' },
//     { field: 'from', headerName: 'From', width: 130, headerClassName: 'pink-header',renderCell: (params) => (
//     <div
//       style={{
//         whiteSpace: 'normal',
//         wordBreak: 'break-word',
//         overflowWrap: 'break-word',
//         lineHeight: 1.3,
//         padding: '10px 2px',
//         width: '100%',
//       }}
//     >
//       {params.value}
//     </div>
//   ), },
//     { field: 'receivedDate', headerName: 'Received Date', width: 100, headerClassName: 'pink-header' },
//     { field: 'medStartDate', headerName: 'Med Start Date', width: 100, headerClassName: 'pink-header' },
//     { field: 'memberId', headerName: 'Member ID', width: 180, headerClassName: 'pink-header', searchField: 'MemberId' },
//     { field: 'lastName', headerName: 'Last Name', width: 120, headerClassName: 'pink-header', searchField: 'LastName' },
//     { field: 'firstName', headerName: 'First Name', width: 120, headerClassName: 'pink-header', searchField: 'FirstName' },
//     { field: 'priority', headerName: 'Priority', width: 100, headerClassName: 'pink-header', searchField: 'Priority' },
//    {
//   field: 'contract',
//   headerName: 'Contract',
//   width: 276,
//   headerClassName: 'pink-header',
//   searchField: 'Contract',
//   renderCell: (params) => (
//     <div
//       style={{
//         whiteSpace: 'normal',
//         wordBreak: 'break-word',
//         overflowWrap: 'break-word',
//         lineHeight: 1.3,
//         padding: '10px 2px',
//         width: '100%',
//       }}
//     >
//       {params.value}
//     </div>
//   ),
// },
//   ];
  




export const columns = [
  { field: 'authNo', headerName: 'Auth No', flex: 1, headerClassName: 'pink-header' },
  { field: 'from', headerName: 'From', flex: 1.2, headerClassName: 'pink-header', renderCell: (params) => (
      <div
        style={{
        display: 'flex',
        alignItems: 'center',   // vertical center
        justifyContent: 'left', // horizontal center
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.3,
        textAlign: 'left',
        padding: '2px 4px', // keep small padding
        width: '100%',
        height: '100%',     // ensures full cell height for vertical centering
      }}
      >
        {params.value}
      </div>
    ), },
  { field: 'receivedDate', headerName: 'Received Date', flex: 1, headerClassName: 'pink-header' },
  { field: 'medStartDate', headerName: 'Med Start Date', flex: 1, headerClassName: 'pink-header' },
  { field: 'memberId', headerName: 'Member ID', flex: 1.2, headerClassName: 'pink-header', searchField: 'MemberId' },
  { field: 'lastName', headerName: 'Last Name', flex: 1, headerClassName: 'pink-header', searchField: 'LastName' },
  { field: 'firstName', headerName: 'First Name', flex: 1, headerClassName: 'pink-header', searchField: 'FirstName' },
  { field: 'priority', headerName: 'Priority', flex:.8, headerClassName: 'pink-header', searchField: 'Priority' },
   
 {
  field: 'contract',
  headerName: 'Contract',
  flex: 2,
  headerClassName: 'pink-header',
  searchField: 'Contract',
  renderCell: (params) => (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',   // vertical center
        justifyContent: 'left', // horizontal center
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.3,
        textAlign: 'left',
        padding: '2px 4px', // keep small padding
        width: '100%',
        height: '100%',     // ensures full cell height for vertical centering
      }}
    >
      {params.value}
    </div>
  ),
},
];
